/** Minimal structural event shape so these helpers work with both native and React synthetic keyboard events. */
interface KeyEvent {
  keyCode: number;
  preventDefault(): void;
  stopPropagation(): void;
}

const isExecuteKeyCode = (keyCode: number): boolean => [13, 32].includes(keyCode);

export const onExecuteKeyDown = (callback?: (event: any) => unknown) => (event: KeyEvent) => {
  if (typeof callback !== 'function') {
    return null;
  }
  if (isExecuteKeyCode(event.keyCode)) {
    event.preventDefault();
    event.stopPropagation();
    return callback(event);
  }
};

export const onVerticalArrowNavigation = (fetchItems?: () => HTMLElement[]) => onArrowNavigation(fetchItems, 38, 40);

export const onHorizontalArrowNavigation = (fetchItems?: () => HTMLElement[]) => onArrowNavigation(fetchItems, 37, 39);

const onArrowNavigation = (fetchItems: any, backKeyCode: number, nextKeyCode: number) => (event: KeyEvent) => {
  if (typeof fetchItems !== 'function') {
    return null;
  }
  const items: HTMLElement[] = fetchItems();
  let focusFunction;

  if (isExecuteKeyCode(event.keyCode)) {
    focusFunction = focusNext;
  } else {
    switch (event.keyCode) {
      case backKeyCode:
        focusFunction = focusPrevious;
        break;
      case nextKeyCode:
        focusFunction = focusNext;
        break;
    }
  }
  if (focusFunction) {
    event.preventDefault();
    event.stopPropagation();
    focusFunction(items);
  }
};

const getActiveIndex = (items: HTMLElement[]): number | undefined => {
  if (!items || !items.length) {
    return;
  }
  return items.indexOf(document.activeElement as HTMLElement);
};

const focusNext = (items: HTMLElement[]): void => {
  const activeIndex = getActiveIndex(items);
  if (typeof activeIndex === 'undefined') {
    return;
  }

  let nextIndex;
  if (activeIndex === -1) {
    nextIndex = 0;
  } else {
    nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
  }
  items[nextIndex].focus();
};

const focusPrevious = (items: HTMLElement[]): void => {
  const activeIndex = getActiveIndex(items);
  if (typeof activeIndex === 'undefined') {
    return;
  }

  let prevIndex;
  if (activeIndex === -1) {
    prevIndex = items.length - 1;
  } else {
    prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
  }
  items[prevIndex].focus();
};
